import { Injectable } from '@angular/core';


import { apiUrlEnum } from 'app/enums/api-endpoints.enums';

import { ResponseServiceActionStateHistory, ResponseServiceAction, ResponseServiceActionChats, AnyProviderResponders, ResponseService } from 'app/interfaces/response-service.interface';
import { PushToUser } from 'app/interfaces/communication.interface';
import { UserDetail } from 'app/interfaces/user.interface';

import { ResponseServiceActionStateType } from 'app/types/responseService.types';
import { ResponderStatusType } from 'app/types/responseService.types';

import { AuthService } from '../../core/auth.service';
import { DataService } from '../dataService/data.service';
import { CustomClientService } from '../customClients/customClient.service';
import Swal from 'sweetalert2';
import { firestore } from 'firebase';
import { timeStampDataService } from 'app/services/function/function.timestamp.service';
import { time } from 'console';
interface RespondersDetail {
    userDetail: UserDetail;
    distanceAway: number;
    outsideRadius: boolean;
    responderStatus: ResponderStatusType;
    marker: any;
}

@Injectable()
export class ResponseServiceService {

    // Constructor for the ResponseServiceService class
    constructor(private dataService: DataService, private authService: AuthService, private customClientService: CustomClientService,public timestampService: timeStampDataService) { 
        console.debug('ResponseServiceService: instantiated');
    }

    // Method to add history to a response service action
    async addResponseActionSaveStateHistory(
        message: string, 
        state: ResponseServiceActionStateType, 
        responseServiceAction: ResponseServiceAction, 
        escalation: boolean = false,
        data?: any,
        ): Promise<string | void> {
        console.debug('ResponseServiceService: addResponseActionSaveStateHistory - start');
        let timestamp: firebase.firestore.Timestamp;
        await this.timestampService.getServerTimeStampData().then(data => { 
                timestamp = data;
        }).catch(rejection => {
            console.error(rejection);
            Swal.close();
            Swal.fire({
                title: "Error Creating Timestamp for addResponseActionSaveStateHistory.",
                text: rejection,
                icon: "error",
                confirmButtonText: "Ok",
            });
            return;
        });
        try {
            // Creating history object
            debugger;
            const historyObject: ResponseServiceActionStateHistory = {
                changeOwnerDisplayName: escalation ? "Escalation" : this.authService.appUser.userDetail.firstName + ' ' + this.authService.appUser.userDetail.lastName,
                changeOwnerKey: this.authService.appUser.userDetail.key,
                changeOwnerClientName: this.authService.appUser.userClient.name,
                changeOwnerClientKey: this.authService.appUser.userClient.key,
                dateUpdated: timestamp,
                state: state,
                message: message
            }

            // If additional data is provided, include it in the history object
            if (data) {
                historyObject.data = data;
            }

            // Push history object into response service action's state history
            responseServiceAction.stateHistory.push(historyObject)
            if (escalation) {
                responseServiceAction.escalated = escalation;
            }

            // Notify custom client service about response service status change
            this.customClientService.stratPayResponseServiceStatusChange(responseServiceAction)

            console.debug('ResponseServiceService: addResponseActionSaveStateHistory - end');
            return await this.dataService.updateFireStoreData('responseServiceActions', responseServiceAction);
        } 
        catch (exception) {
            console.error('ResponseServiceService: addResponseActionSaveStateHistory - error', exception);
        }
    }

    async anyProviderAssignNewResponder(responseServiceAction: ResponseServiceAction,responderSelectedKey: String): Promise<string | void>  {
        console.debug('ResponseServiceService: anyProviderAssignNextResponder - start');
        let timestamp: firebase.firestore.Timestamp;
        await this.timestampService.getServerTimeStampData().then(data => { 
                timestamp = data;
        }).catch(rejection => {
            console.error(rejection);
            Swal.close();
            Swal.fire({
                title: "Error Creating Timestamp for Transfer Request.",
                text: rejection,
                icon: "error",
                confirmButtonText: "Ok",
            });
            return;
        });
        try {
            //Assign New Responder
            const oldResponderIndex = responseServiceAction.anyProviderResponders.findIndex((responder) => (responder.selected == true));
            const newResponderIndex = responseServiceAction.anyProviderResponders.findIndex((responder) => (responder.key == responderSelectedKey));
            if (oldResponderIndex != -1 && newResponderIndex != -1) {
                responseServiceAction.anyProviderResponders[oldResponderIndex].selected = false;
                responseServiceAction.anyProviderResponders[oldResponderIndex].clientAcceptanceState = 'recalled';
                const responder = responseServiceAction.anyProviderResponders[newResponderIndex]
                responseServiceAction.anyProviderResponders[newResponderIndex].selected = true;
                responseServiceAction.anyProviderResponders[newResponderIndex].clientAcceptanceState = 'awaiting';
                responseServiceAction.anyProviderResponders[newResponderIndex].clientAssignedTime = timestamp;
                console.log(`[anyProviderQueueTaskHandler]- Assigning Next Responder:${responder.name}`);
                console.log(`[anyProviderQueueTaskHandler]- Fetching Response Services...`);
                let retrievedResponseService: ResponseService[] = [];
                await firestore().collection('responseServices').where('clientKey','==',responseServiceAction.anyProviderResponders[newResponderIndex].clientKey).where('category','==','armedResponse').get().then((responseServices) => {
                    for (const doc of responseServices.docs) {
                        retrievedResponseService.push(doc.data() as ResponseService);
                    }
                }).catch((error) => {
                    console.error(`[generalProvider_v1] - Error occurred while fetching anyProvder responseService: ${error}`);
                    throw Error(`[generalProvider_v1] - Error occurred while fetching anyProvder responseService:${error}`);
                });
                if (retrievedResponseService.length == 0) {
                    //WHAT SHOULD WE DO HERE??
                    console.error('Error occurred while fetching anyProvder responseService: ');
                    throw Error('Error occurred while fetching anyProvder responseService:');
                }

                console.log(`[anyProviderQueueTaskHandler]- Fetched ${retrievedResponseService.length}`);
                for(const responseServiceForAnyProvider of retrievedResponseService) {
                    
                    if (responseServiceForAnyProvider.category == 'armedResponse' && (responseServiceForAnyProvider.responders.findIndex((responder) => responder.key == responseServiceAction.anyProviderResponders[newResponderIndex].key) != -1)) {
                        const responseService = responseServiceForAnyProvider;
                        console.log(`[anyProviderQueueTaskHandler]- Response Service (${responseService.name}) Linked to Responder`);
                        if (responseService.isDirectRequestToResponders) {
                            console.log(`[anyProviderQueueTaskHandler]- AutoDispatch Enabled. Sending directly to Responder.`);
                            responseServiceAction.anyProviderResponders[newResponderIndex].clientAcceptanceState = 'accepted';
                            responseServiceAction.anyProviderResponders[newResponderIndex].selected = true;
                            responseServiceAction.anyProviderResponders[newResponderIndex].clientAssignedTime = timestamp;
                            responseServiceAction.anyProviderResponders[newResponderIndex].responderAssignedTime = timestamp;
                        }

                        console.log(`[anyProviderQueueTaskHandler]- updating firestore...`);
                        await firestore().collection("responseServiceActions").doc(responseServiceAction.key).update({
                            escalated: responseServiceAction.escalated || false,
                            anyProviderResponders: responseServiceAction.anyProviderResponders,
                            responseServiceClientKey: responseService.clientKey,
                            responseServiceClientName: responseService.clientName,
                            responseServiceKey: responseService.key,
                            responseServiceName: responseService.name,
                            state: 'open',
                            stateHistory: firestore.FieldValue.arrayUnion({
                                changeOwnerDisplayName: `${this.authService.appUser.userDetail.firstName} ${this.authService.appUser.userDetail.lastName}`,
                                changeOwnerKey: this.authService.appUser.userDetail.key,
                                dateUpdated: firestore.Timestamp.now(),
                                changeOwnerClientName: this.authService.appUser.userDetail.clientName,
                                changeOwnerClientKey: this.authService.appUser.userDetail.clientKey,
                                state: responseServiceAction.state,
                                message: `${responseServiceAction.anyProviderResponders[oldResponderIndex].name} recalled. Reason: Dispatch timeout reached. Assigning next Responder.`,
                            },
                            {
                                changeOwnerDisplayName: `${this.authService.appUser.userDetail.firstName} ${this.authService.appUser.userDetail.lastName}`,
                                changeOwnerKey: this.authService.appUser.userDetail.key,
                                dateUpdated: firestore.Timestamp.now(),
                                changeOwnerClientName: this.authService.appUser.userDetail.clientName,
                                changeOwnerClientKey: this.authService.appUser.userDetail.clientKey,
                                state: responseService.isDirectRequestToResponders === true ? 'awaitResponderPickup' : 'open',
                                message: `${responseService.clientName} selected as new Responding Client (${responseService.name} Response Service used).`,
                            },
                            {
                                changeOwnerDisplayName: `${this.authService.appUser.userDetail.firstName} ${this.authService.appUser.userDetail.lastName}`,
                                changeOwnerKey: this.authService.appUser.userDetail.key,
                                dateUpdated: firestore.Timestamp.now(),
                                changeOwnerClientName: this.authService.appUser.userDetail.clientName,
                                changeOwnerClientKey: this.authService.appUser.userDetail.clientKey,
                                state: 'open',
                                message: `${responder.name} selected as next Responder (${responder.distance.text} from site. ETA: ${responder.duration.text}).`,
                            }
                        )
                        });
                        break;
                    }
                }
                console.debug('ResponseServiceService: anyProviderAssignNextResponder - end');
            } else {
                console.error(`Responders Cannot be found - Cancelling operation.`); 
            }
        } 
        catch (exception) {
            console.error('ResponseServiceService: addResponderActionChat - error', exception);
        }
    }

    // Method to add a chat message to a response service action
    async addResponderActionChat(message: string, responseServiceAction: ResponseServiceAction, responders: RespondersDetail[]): Promise<string | void> {
        console.debug('ResponseServiceService: addResponderActionChat - start');
        let timestamp: firebase.firestore.Timestamp;
        await this.timestampService.getServerTimeStampData().then(data => { 
                timestamp = data;
        }).catch(rejection => {
            console.error(rejection);
            Swal.close();
            Swal.fire({
                title: "Error Creating Timestamp for addResponderActionChat.",
                text: rejection,
                icon: "error",
                confirmButtonText: "Ok",
            });
            return;
        });
        try {
            // Creating chat object
            const chatObject: ResponseServiceActionChats = {
                responderKey: this.authService.appUser.userDetail.key,
                responderDisplayName: `${this.authService.appUser.userDetail.firstName} ${this.authService.appUser.userDetail.lastName}`,
                clientName: this.authService.appUser.userClient.name,
                clientKey: this.authService.appUser.userClient.key,
                date: timestamp,
                message: message
            }
    
            // If the responseChats array in the responseServiceAction object is null (i.e., no chats exist yet),
            // we initialize it to an empty array to avoid null pointer exceptions.
            if (responseServiceAction.responseChats == null) {
                responseServiceAction.responseChats = [];
            }
    
            // The chat object is then added to the responseChats array
            responseServiceAction.responseChats.push(chatObject);
    
            // Notify custom client service about response service status change.
            this.customClientService.stratPayResponseServiceStatusChange(responseServiceAction);
    
            responders.forEach(responder => {
                const pushToUser: PushToUser = {
                    message: message,
                    title: this.authService.appUser.userDetail.displayName,
                    fcmToken: responder.userDetail.fcmToken,
                    userKey: this.authService.appUser.userClient.key,
                };
    
                this.dataService.postToFunctions(
                    apiUrlEnum.communication_v1.push_user,
                    pushToUser,
                );
            });

            console.debug('ResponseServiceService: addResponderActionChat - end');
            return await this.dataService.updateFireStoreData('responseServiceActions', responseServiceAction);
        } 
        catch (exception) {
            console.error('ResponseServiceService: addResponderActionChat - error', exception);
        }
    }

    // Method to update a chat message status
    async updateMessageStatus(chatMessage: ResponseServiceActionChats, responseServiceAction: ResponseServiceAction): Promise<string | void> {
        console.debug('ResponseServiceService: updateMessageStatus - start');
        let timestamp: firebase.firestore.Timestamp;
        await this.timestampService.getServerTimeStampData().then(data => { 
            timestamp = data;
            }).catch(rejection => {
                console.error(rejection);
                Swal.close();
                Swal.fire({
                    title: "Error Creating Timestamp for updateMessageStatus.",
                    text: rejection,
                    icon: "error",
                    confirmButtonText: "Ok",
                });
                return;
    });
        try {
            // Find the chat message in the response service action's chats, and update its read status
            var responseServiceActionChatMessage = responseServiceAction.responseChats.filter((obj) => obj.message === chatMessage.message && obj.date.isEqual(chatMessage.date as firebase.firestore.Timestamp))[0];

            if (responseServiceActionChatMessage) {
                responseServiceActionChatMessage.read = timestamp;
            } else {
                Swal.fire({
                    title: "Error Creating Timestamp for Response Chat.",
                    text: "Unable to find message.",
                    icon: "error",
                    confirmButtonText: "Ok",
                });

                return;
            }

            // Notify custom client service about response service status change
            this.customClientService.stratPayResponseServiceStatusChange(responseServiceAction)

            console.debug('ResponseServiceService: updateMessageStatus - end');
            return await this.dataService.updateFireStoreData('responseServiceActions', responseServiceAction);
        } 
        catch (exception) {
            console.error('ResponseServiceService: updateMessageStatus - error', exception);
        }
    }
}
